import { Element } from "@xmpp/xml"
import { AUTOHOFS_NS, Autohof } from "@/lib/autohofs"

export type AutohofsResult = {
  autohofs: Autohof[]
  vhost?: string
}

export default class AutohofsParser {
  static parse(stanza: Element): AutohofsResult | undefined {
    if (stanza.name !== "iq") return

    const command = stanza.getChild(
      "command",
      "http://jabber.org/protocol/commands",
    )
    if (!command) return

    const autohofsElement = command.getChild("autohofs", AUTOHOFS_NS)
    if (!autohofsElement) return

    const autohofs = autohofsElement
      .getChildren("autohof", AUTOHOFS_NS)
      .flatMap((autohof) => {
        const lat = Number.parseFloat(autohof.getAttr("lat") ?? "")
        const lon = Number.parseFloat(autohof.getAttr("lon") ?? "")

        if (!Number.isFinite(lat) || !Number.isFinite(lon)) {
          return []
        }

        return [
          {
            lat,
            lon,
            name: autohof.getAttr("name") ?? "",
            address: autohof.getAttr("address") ?? "",
          },
        ]
      })

    return {
      autohofs,
      vhost: autohofsElement.getAttr("vhost") ?? undefined,
    }
  }
}
